"use client"

import { Spinner } from "./spinner";

export function RouteGuardLoading({ label }: { label?: string }) {
  return (
    <div className='flex min-h-[var(--app-height)] w-full flex-col items-center justify-center gap-3 bg-background px-4 py-8'>
      <Spinner className='text-primary size-8' label='Loading' />
      {label ? <p className='max-w-sm text-center text-sm text-muted-foreground'>{label}</p> : null}
    </div>
  )
}
